/**
 * Decode the `exp` claim from a JWT and return it in milliseconds.
 * Returns `null` if the token is malformed or has no `exp`.
 */
export const getTokenExpiration = (token: string): number | null => {
	try {
		const base64Url = token.split('.')[1];
		const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
		const jsonPayload = decodeURIComponent(
			atob(base64)
				.split('')
				// biome-ignore lint/style/useTemplate: Init Biome
				.map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
				.join('')
		);
		const { exp } = JSON.parse(jsonPayload);
		return typeof exp === 'number' ? exp * 1000 : null;
	} catch {
		return null;
	}
};

/**
 * Check whether a JWT is expired (or will expire within `marginMs` milliseconds).
 * Returns `true` if the token is expired/malformed, `false` otherwise.
 */
export const isTokenExpired = (token: string, marginMs = 0): boolean => {
	const exp = getTokenExpiration(token);
	if (exp === null) return true;
	return Date.now() + marginMs >= exp;
};
